export enum NoPaymentReasonClaro {
  CANCELACION_NO_ATENDIDA = 'CANCELACION_NO_ATENDIDA',
  DESEMPLEO = 'DESEMPLEO',
  ENFERMEDAD = 'ENFERMEDAD',
  INCREMENTO_VALOR_FACTURA = 'INCREMENTO_VALOR_FACTURA',
  MAL_SERVICIO = 'MAL_SERVICIO',
  MALA_INFORMACION_VENTAS = 'MALA_INFORMACION_VENTAS',
  OLVIDO_DE_PAGO = 'OLVIDO_DE_PAGO',
  POSIBLE_FRAUDE = 'POSIBLE_FRAUDE',
  PRESTANOMBRE = 'PRESTANOMBRE',
  TRASLADO_NO_EFECTUADO = 'TRASLADO_NO_EFECTUADO',
  TEMPORALMENTE_SIN_INGRESOS = 'TEMPORALMENTE_SIN_INGRESOS',
}

export const noPaymentReasonClaro = () => [
  {
    label: 'Cancelación no atendida',
    value: NoPaymentReasonClaro.CANCELACION_NO_ATENDIDA,
  },
  {
    label: 'Desempleo',
    value: NoPaymentReasonClaro.DESEMPLEO,
  },
  {
    label: 'Enfermedad',
    value: NoPaymentReasonClaro.ENFERMEDAD,
  },
  {
    label: 'Incremento valor factura',
    value: NoPaymentReasonClaro.INCREMENTO_VALOR_FACTURA,
  },
  {
    label: 'Mal servicio',
    value: NoPaymentReasonClaro.MAL_SERVICIO,
  },
  {
    label: 'Mala información - Ventas',
    value: NoPaymentReasonClaro.MALA_INFORMACION_VENTAS,
  },
  {
    label: 'Olvido de pago',
    value: NoPaymentReasonClaro.OLVIDO_DE_PAGO,
  },
  {
    label: 'Posible fraude',
    value: NoPaymentReasonClaro.POSIBLE_FRAUDE,
  },
  {
    label: 'Prestanombre',
    value: NoPaymentReasonClaro.PRESTANOMBRE,
  },
  {
    label: 'Traslado no efectuado',
    value: NoPaymentReasonClaro.TRASLADO_NO_EFECTUADO,
  },
  {
    label: 'Temporalmente sin ingresos',
    value: NoPaymentReasonClaro.TEMPORALMENTE_SIN_INGRESOS,
  },
];
